import type { IThresherAdView, IToolsAdView, ITractorAdView } from "@finn-no/adview-provider-frontend-types";
import type { AgricultureAd } from "@mobility-item-page/types";
import { Effect } from "../Effect.tsx";
import { Fuel } from "../Fuel.tsx";
import { Make } from "../Make.tsx";
import { Model } from "../Model.tsx";
import { ModelYear } from "../ModelYear.tsx";
import { VolumeLitre } from "../VolumeLitre.tsx";
import { Weight } from "../Weight.tsx";
import { Category } from "./Category.tsx";
import { HoursUsed } from "./HoursUsed.tsx";
import { Tyres } from "./Tyres.tsx";

export const AgricultureSpecifications = ({ ad }: { ad: AgricultureAd }) => {
  switch (ad.adViewType) {
    case "agriculture-tractor":
      return AgricultureTractorSpecifications({ ad });
    case "agriculture-thresher":
      return AgricultureThresherSpecifications({ ad });
    case "agriculture-tools":
      return AgricultureToolsSpecifications({ ad });
    default:
      return null;
  }
};

const AgricultureTractorSpecifications = ({ ad }: { ad: ITractorAdView }) => {
  return (
    <>
      {/*General information*/}
      <Make make={ad.make} />
      <Model model={ad.model} />
      <ModelYear year={ad.year} />
      <HoursUsed hoursUsed={ad.hours_used} />

      {/*Product properties*/}
      <Fuel fuel={ad.engine?.fuel} />
      <Effect effect={ad.engine?.effect} />
      <VolumeLitre volume={ad.engine?.volume} />
      <Weight weight={ad.weight} />
      <Tyres tyres={ad.tyres} />

      {/*Appearance*/}

      {/*Registration, warranty, owners, etc*/}
    </>
  );
};

const AgricultureThresherSpecifications = ({ ad }: { ad: IThresherAdView }) => {
  return (
    <>
      {/*General information*/}
      <Make make={ad.make} />
      <Model model={ad.model} />
      <ModelYear year={ad.year} />
      <HoursUsed hoursUsed={ad.hours_used} />

      {/*Product properties*/}
      <Fuel fuel={ad.engine?.fuel} />
      <Effect effect={ad.engine?.effect} />
      <VolumeLitre volume={ad.engine?.volume} />
      <Weight weight={ad.weight} />

      {/*Appearance*/}

      {/*Registration, warranty, owners, etc*/}
    </>
  );
};

const AgricultureToolsSpecifications = ({ ad }: { ad: IToolsAdView }) => {
  return (
    <>
      {/*General information*/}
      <Make make={ad.make} />
      <Model model={ad.model} />
      <Category category={ad.category} />
      <ModelYear year={ad.year} />

      {/*Product properties*/}
      <Weight weight={ad.weight} />

      {/*Appearance*/}

      {/*Registration, warranty, owners, etc*/}
    </>
  );
};
